import Axios from 'axios'
import { IFinalConsumerValues } from 'models/FinalConsumer'
const urlBase = 'p_cc_consfinal'

export const finalConsumerConfirmApi = async (params: IFinalConsumerValues) => {
	const response = await Axios.post(`${urlBase}/confirmar`, params)
	return response.data
}
